export enum Found {

    Conservative = 0,
    Balanced = 1,
    Dynamic = 2

}
